/* ============================================================
   SAPELO EQUIPMENT CO. — MERGED SHOPIFY JAVASCRIPT
   Source merge: proto-script.js + proto-collection.js
   All feature initialization is deferred until DOMContentLoaded.
============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  // Search overlay
  (function() {
    var trigger = document.getElementById('searchTrigger');
    var overlay = document.getElementById('searchOverlay');
    var closeBtn = document.getElementById('searchClose');
    var input = overlay ? overlay.querySelector('.search-overlay-input') : null;

    function openSearch() {
      if (!overlay) return;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      setTimeout(function() { if (input) input.focus(); }, 100);
    }

    function closeSearch() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    if (trigger) trigger.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeSearch(); });
    if (overlay) overlay.addEventListener('click', function(e) { if (e.target === overlay) closeSearch(); });
  })();

  // Shopify predictive search
  (function() {
    var input = document.querySelector('[data-predictive-search-input]');
    var results = document.querySelector('[data-predictive-search-results]');
    if (!input || !results) return;
    var timer;
    input.addEventListener('input', function() {
      var query = input.value.trim();
      clearTimeout(timer);
      if (query.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function() {
        // Search products, collections, AND pages
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product,collection,page&resources[limit]=8')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var res = (data.resources && data.resources.results) || {};
            var products    = res.products    || [];
            var collections = res.collections || [];
            var pages       = res.pages       || [];
            var html = '';

            if (products.length) {
              html += '<p class="search-group-label">Products</p>';
              html += products.slice(0,6).map(function(p) {
                var img = p.featured_image
                  ? '<img src="' + p.featured_image.url + '&width=120" width="52" height="52" alt="" />'
                  : '<div class="search-result-no-img"></div>';
                var price = '';
                return '<a class="predictive-search-result" href="' + p.url + '">' +
                  '<div class="search-result-img">' + img + '</div>' +
                  '<div class="search-result-info">' +
                    '<span class="search-result-title">' + p.title + '</span>' +
                  '</div>' +
                '</a>';
              }).join('');
            }

            if (collections.length) {
              html += '<p class="search-group-label">Categories</p>';
              html += collections.slice(0,3).map(function(c) {
                return '<a class="predictive-search-result predictive-search-result--text" href="' + c.url + '">' +
                  '<div class="search-result-img search-result-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg></div>' +
                  '<div class="search-result-info"><span class="search-result-title">' + c.title + '</span><span class="search-result-type">Collection</span></div>' +
                '</a>';
              }).join('');
            }

            if (pages.length) {
              html += '<p class="search-group-label">Pages</p>';
              html += pages.slice(0,3).map(function(pg) {
                return '<a class="predictive-search-result predictive-search-result--text" href="' + pg.url + '">' +
                  '<div class="search-result-img search-result-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></div>' +
                  '<div class="search-result-info"><span class="search-result-title">' + pg.title + '</span><span class="search-result-type">Page</span></div>' +
                '</a>';
              }).join('');
            }

            if (!html) {
              html = '<p class="search-no-results">No results found. Press Enter to search all.</p>';
            }
            results.innerHTML = html;
          })
          .catch(function() { results.innerHTML = ''; });
      }, 220);
    });
  })();


  /* ── HOMEPAGE BEHAVIOR — MERGED FROM proto-script.js ── */
  /* ── Mobile Menu ── */
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const expanded = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!expanded));
      mobileNav.setAttribute('aria-hidden', String(expanded));
      document.body.style.overflow = expanded ? '' : 'hidden';
    });
    document.addEventListener('click', (e) => {
      if (!mobileNav.contains(e.target) && !menuBtn.contains(e.target)) {
        menuBtn.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── Mobile Submenus ── */
  document.querySelectorAll('.mobile-trigger').forEach((btn) => {
    btn.addEventListener('click', () => {
      const sub = btn.nextElementSibling;
      if (!sub) return;
      const open = sub.classList.toggle('open');
      const chevron = btn.querySelector('.chevron');
      if (chevron) chevron.style.transform = open ? 'rotate(180deg)' : '';
    });
  });

  /* ── Desktop Dropdown Portal ──
     Clones dropdowns to <body> level with position:fixed so they
     can never be hidden behind any section's stacking context.
  ── */
  const portalEl = document.createElement('div');
  portalEl.style.cssText = 'position:fixed;top:0;left:0;width:0;height:0;overflow:visible;z-index:999999;pointer-events:none;';
  document.body.appendChild(portalEl);

  document.querySelectorAll('.has-dropdown').forEach(function (item) {
    const trigger = item.querySelector('.nav-trigger, .nav-link');
    const originalDropdown = item.querySelector('.dropdown');
    if (!trigger || !originalDropdown) return;

    // Build a portal clone
    const clone = document.createElement('div');
    clone.innerHTML = originalDropdown.innerHTML;
    clone.style.cssText = [
      'display:none',
      'position:fixed',
      'pointer-events:auto',
      'background:#1A0F0A',
      'border:1px solid rgba(255,255,255,0.1)',
      'border-top:3px solid #E8630A',
      'padding:1.25rem 1.5rem',
      'min-width:220px',
      'z-index:999999',
      'box-shadow:0 16px 48px rgba(0,0,0,0.8)',
      'border-radius:0 0 4px 4px',
    ].join(';');

    // Style links inside clone
    clone.querySelectorAll('a').forEach(function(a) {
      a.style.cssText = 'display:block;padding:0.4rem 0;color:rgba(255,255,255,0.75);text-decoration:none;font-family:Barlow,sans-serif;font-size:0.9rem;';
      a.addEventListener('mouseenter', function() { a.style.color = '#E8630A'; });
      a.addEventListener('mouseleave', function() { a.style.color = 'rgba(255,255,255,0.75)'; });
    });

    clone.querySelectorAll('.dropdown-label').forEach(function(lbl) {
      lbl.style.cssText = 'display:block;font-family:"Barlow Condensed",sans-serif;font-size:0.7rem;font-weight:700;letter-spacing:0.1em;color:#E8630A;text-transform:uppercase;padding-bottom:0.5rem;margin-bottom:0.25rem;border-bottom:1px solid rgba(255,255,255,0.08);';
    });

    clone.querySelectorAll('.dropdown-grid').forEach(function(g) {
      g.style.cssText = 'display:flex;gap:2rem;';
    });

    portalEl.appendChild(clone);

    let hideTimer;

    function show() {
      clearTimeout(hideTimer);
      const rect = item.getBoundingClientRect();
      clone.style.top  = rect.bottom + 'px';
      clone.style.left = rect.left + 'px';
      clone.style.display = 'block';
    }

    function hide() {
      hideTimer = setTimeout(function() {
        clone.style.display = 'none';
      }, 100);
    }

    item.addEventListener('mouseenter', show);
    item.addEventListener('mouseleave', hide);
    clone.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
    clone.addEventListener('mouseleave', hide);
  });

  /* ── Sticky header shadow ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 4px 24px rgba(0,0,0,0.5)' : '';
    }, { passive: true });
  }

  /* ── Banner Slider ── */
  const slides = document.querySelectorAll('.banner-slide');
  const dots   = document.querySelectorAll('.banner-dot');
  let current  = 0;
  let autoplay;

  function goToSlide(n) {
    slides[current].classList.remove('active');
    dots[current] && dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current] && dots[current].classList.add('active');
  }
  if (slides.length > 0) {
    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      clearInterval(autoplay);
      goToSlide(i);
      autoplay = setInterval(() => goToSlide(current + 1), 5000);
    }));
    autoplay = setInterval(() => goToSlide(current + 1), 5000);
  }

  /* ── Scroll-reveal (Shopify-safe CSS classes) ── */
  const revealEls = document.querySelectorAll(
    '.category-card, .package-card, .testi-card, .location-card, .service-option, .about-img'
  );
  if ('IntersectionObserver' in window && revealEls.length) {
    revealEls.forEach((el) => el.classList.add('reveal'));
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('revealed'); observer.unobserve(e.target); }
      }),
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach((el) => observer.observe(el));
  }

  /* ── Smooth anchor scroll ── */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const id = anchor.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
        if (mobileNav) { mobileNav.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Header Search — navigate to collection.html?q= ──
     SHOPIFY: form action swaps to /search, this preserves
     the ?q= param behavior identically. ── */
  document.querySelectorAll('.mobile-search form').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('input[type="search"]');
      const query = input ? input.value.trim() : '';
      e.preventDefault();
      const base = form.getAttribute('action') || '/search';
      if (query) {
        window.location.href = base + '?q=' + encodeURIComponent(query);
      } else {
        window.location.href = base;
      }
    });
  });

  /* ── FAQ Accordion (financing.html) ── */
  document.querySelectorAll('.faq-item').forEach((item) => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!question || !answer) return;
    answer.style.display = item.classList.contains('open') ? 'block' : 'none';
    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach((openItem) => {
        if (openItem !== item) {
          openItem.classList.remove('open');
          const a = openItem.querySelector('.faq-answer');
          if (a) a.style.display = 'none';
        }
      });
      item.classList.toggle('open', !isOpen);
      answer.style.display = isOpen ? 'none' : 'block';
    });
  });

  /* ── Rental filter tabs (rentals.html) ── */
  const rentalTabs = document.querySelectorAll('.rental-filter-tab');
  const rentalCards = document.querySelectorAll('.rental-card');
  if (rentalTabs.length && rentalCards.length) {
    rentalTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        rentalTabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');
        const cat = tab.dataset.category;
        rentalCards.forEach((card) => {
          if (cat === 'all' || card.dataset.category === cat) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  /* ── Category tabs (packages.html) ── */
  const catTabs = document.querySelectorAll('.category-tab');
  const catCards = document.querySelectorAll('[data-package-category]');
  if (catTabs.length && catCards.length) {
    catTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        catTabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');
        const cat = tab.dataset.category;
        catCards.forEach((card) => {
          if (cat === 'all' || card.dataset.packageCategory === cat) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  /* ── COLLECTION & PRODUCT BEHAVIOR — MERGED FROM proto-collection.js ── */
  /* ── HP Range slider ── */
  const hpRange = document.getElementById('hpRange');
  const hpVal   = document.getElementById('hpVal');
  if (hpRange && hpVal) {
    hpRange.addEventListener('input', () => {
      hpVal.textContent = hpRange.value + ' HP';
    });
  }

  /* ── Lift Range slider ── */
  const liftRange = document.getElementById('liftRange');
  const liftVal   = document.getElementById('liftVal');
  if (liftRange && liftVal) {
    liftRange.addEventListener('input', () => {
      const t = liftRange.value / 10;
      liftVal.textContent = t.toFixed(1) + 'T';
    });
  }

  /* ── Mobile filter toggle ── */
  const filterToggle = document.getElementById('filterToggle');
  const sidebar      = document.querySelector('.collection-sidebar');
  if (filterToggle && sidebar) {
    filterToggle.addEventListener('click', () => {
      const open = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', String(!open));
      sidebar.classList.toggle('open');
    });
  }

  /* ── Clear filters ── */
  const clearBtn = document.getElementById('clearFilters');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      document.querySelectorAll('.filter-check input').forEach(cb => {
        cb.checked = cb.value === 'all';
      });
      if (hpRange)   { hpRange.value = hpRange.max; hpVal && (hpVal.textContent = hpRange.max + ' HP'); }
      if (liftRange) { liftRange.value = liftRange.max; liftVal && (liftVal.textContent = '3.5T'); }
      if (document.getElementById('sortSelect')) document.getElementById('sortSelect').value = '';
    });
  }

  /* ── Product image gallery (product page) ── */
  const thumbs   = document.querySelectorAll('.thumb');
  const mainImg  = document.querySelector('.product-main-img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          const newSrc = thumb.dataset.img;
          mainImg.src = newSrc;
          if (mainImg.srcset) {
            mainImg.srcset = [600,900,1200,1600].map(w =>
              newSrc.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'
            ).join(', ');
          }
          mainImg.style.opacity = '1';
        }, 150);
      }
    });
  });

  /* ── Product tabs ── */
  const tabs   = document.querySelectorAll('.product-tab');
  const panels = document.querySelectorAll('.product-tab-panel');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      tabs.forEach(t => { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
      panels.forEach(p => p.hidden = true);
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      const panel = document.getElementById('tab-' + target);
      if (panel) panel.hidden = false;
    });
  });

  /* ── Request pricing form toggle ──
     Visible by default on desktop (CSS), collapsed on mobile by default.
     On mobile, toggling adds/removes the .is-open class (see collection.css). ── */
  const openQuoteBtn = document.getElementById('openQuoteForm');
  const quoteForm    = document.getElementById('quoteForm');
  if (openQuoteBtn && quoteForm) {
    openQuoteBtn.addEventListener('click', () => {
      const nowOpen = quoteForm.classList.toggle('is-open');
      openQuoteBtn.textContent = nowOpen ? 'HIDE FORM' : 'REQUEST PRICING BY EMAIL';
      if (nowOpen) {
        quoteForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  /* ── Collection search param handler ──
     Reads ?search= (and legacy ?q=) from URL, pre-fills the search input, and shows
     a "Showing results for: X" banner at the top of the collection.
     SHOPIFY: replaced by {{ search.terms }} on native /search template. ── */
  (function handleSearchParam() {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('search') || params.get('q');
    if (!q) return;

    // Pre-fill header search input(s)
    document.querySelectorAll('.header-search input[type="search"]').forEach((input) => {
      input.value = q;
    });

    // Build and insert the results banner at the top of the collection hero
    const hero = document.querySelector('.collection-hero');
    if (hero) {
      const banner = document.createElement('div');
      banner.className = 'search-results-banner';
      banner.innerHTML = 'Showing results for: <span>' + q.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>' +
        ' <a href="' + window.location.pathname + '" class="clear-search">Clear search</a>';
      hero.parentNode.insertBefore(banner, hero);
    }

    // Update collection title/description contextually
    const title = document.querySelector('.collection-title');
    if (title) {
      title.innerHTML = 'SEARCH RESULTS: <span class="text-orange">' + q.replace(/</g, '&lt;').replace(/>/g, '&gt;').toUpperCase() + '</span>';
    }
  })();

  // ── VARIANT SELECTOR (apparel pages) ──
  class VariantSelector {
    constructor() {
      this.pills = document.querySelectorAll('.variant-pill');
      if (!this.pills.length) return;
      this.pills.forEach(pill => {
        pill.addEventListener('click', () => {
          this.pills.forEach(p => p.classList.remove('active'));
          pill.classList.add('active');
          // Update Shopify cart form variant ID
          const variantInput = document.querySelector('[name="id"]');
          if (variantInput) {
            variantInput.value = pill.dataset.variantId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
  }

  // ── COLLECTION FILTERS (Shopify URL-based) ──
  class CollectionFilters {
    constructor() {
      this.filterButtons = document.querySelectorAll('[data-filter-tag]');
      if (!this.filterButtons.length) return;
      this.filterButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const tag = btn.dataset.filterTag;
          if (tag === 'all') {
            window.location.href = window.location.pathname;
          } else {
            window.location.href = `${window.location.pathname}?filter.p.tag=${encodeURIComponent(tag)}`;
          }
        });
      });
    }
  }
  new VariantSelector();
  new CollectionFilters();
});
